import { render, staticRenderFns } from "./AwayStatusIndicator.vue?vue&type=template&id=4043ee32&functional=true&"
import script from "./AwayStatusIndicator.vue?vue&type=script&lang=js&"
export * from "./AwayStatusIndicator.vue?vue&type=script&lang=js&"
import style0 from "./AwayStatusIndicator.vue?vue&type=style&index=0&id=4043ee32&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../kiwiirc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports